import React from 'react';
import './Ecology.scss';
import ChildCompany from './childCompany'
import Bussiness from './bussiness'
import Partner from './partner'
import BannerZx from '../BannerZx'
const $ = window.$;
let Swiper = window.Swiper
class Ecology extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      bannerImages: [{
        imgPath: require("img/CompanyProfilebg.png"),
        imgHDPath: `${require("img/CompanyProfilebg.png")} 1x,${require("img/CompanyProfilebg@2x.png")} 2x,${require("img/CompanyProfilebg@3x.png")} 3x`,
        attachURL: "/"
      }, ],
      activeTab: 0,
      navSwiper: '',
      orientation: 0,
      bannerHeight: '',
      navTabs: [{
          title: '子公司',
          value: 0
        },
        {
          title: '研究机构',
          value: 1
        },
        {
          title: '战略合作伙伴',
          value: 2
        }
      ],
    }
  }
  componentDidMount() {
    const that = this;
    window.addEventListener('orientationchange', that.updateHeight.bind(that), false);
    this.setState({
      navSwiper: new Swiper('#tab-container', {
        speed: 500,
        autoHeight: true,
        on: {
          slideChangeTransitionStart: function () {
            const top = document.getElementsByClassName('top')[0]
            const topbanner = document.getElementsByClassName('BannerZx')[0]
            const scrollTop = $(window).scrollTop();
            const fixedHeight = top.clientHeight + topbanner.clientHeight
            if (scrollTop >= fixedHeight) {
              window.scrollTo(0, fixedHeight);
            }
            that.state.navSwiper.slideTo(this.activeIndex, 1000, false);
            that.setState({
              activeTab: this.activeIndex
            })
          }
        }
      }),
    })
  }
  updateHeight () {
    const top = document.getElementsByClassName('top')[0]
    const topbanner = document.getElementsByClassName('BannerZx')[0]
    const scrollTop = $(window).scrollTop();
    const fixedHeight = top.clientHeight + topbanner.clientHeight;
    if (scrollTop >= fixedHeight) {
      window.scrollTo(0, fixedHeight);
    }
    this.state.navSwiper.slideTo(this.state.activeTab, 1000, false);
  }
  transferHeight(height) {
    this.setState({
      bannerHeight: height
    });
  }
  handleNavToggle(value) {
    this.setState({
      activeTab: value
    })
    this.state.navSwiper.slideTo(value)
  }
  render() {
    return ( <div className = 'Ecology' >
                <main className = "Ecology-body" >
                <BannerZx />{/* transferHeight={bannerHeight => this.transferHeight(bannerHeight)} */}
                <nav className = "nav" >
                 {
                  this.state.navTabs.map((item, index) =>
                    <span className = {
                      this.state.activeTab === item.value ? 'active' : ''
                    }
                    key = {
                      index
                    }
                    onClick = {
                      () => this.handleNavToggle(item.value)
                    } > {
                      item.title
                    }</span>
                  )
                } </nav>
                  <section className = "swiper-container" id = "tab-container" >
                    <div className = "swiper-wrapper" >
                      <article className = "swiper-slide" >
                        <ChildCompany > </ChildCompany>
                      </article>
                      <article className = "swiper-slide" >
                        <Bussiness ></Bussiness> </article>
                      <article className = "swiper-slide" >
                        <Partner > </Partner>
                      </article>
                    </div>
                  </section>
                </main>
      </div>
    )
  }
}
export default Ecology;
